import React from "react";
import "./spinner.css";

export function LoadingSpinner({message}) {
  return (
    <div className="spin_all">
      <div className="spinner-container">
        <Spinner />
      </div>
      <div>
        {message}
      </div>
    </div>
  );
}


export const Spinner = () =>{
  return (
    <div style={{width:'100%', justifyContent:'center', padding:'20%'}}>
      <div className="loading-spinner">
      </div>
    </div>
  )
}
